module.exports = __webpack_public_path__ + "static/media/Piercing-facial.887f61af.png";